'use client';

import { c as _c } from "react/compiler-runtime";
import { MenuIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Link } from '@/components/ui/link';
import { HEADER_LINKS } from '@/constants/navigation';
export function MobileNav() {
  const $ = _c(12);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("layout.toggle-menu");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MenuIcon />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <DropdownMenuTrigger render={<Button variant="ghost" size="icon" aria-label={t0} className="md:hidden">{t1}</Button>} />;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = HEADER_LINKS.map(link => <DropdownMenuItem key={link.href} render={<Link href={link.href}>{link.icon}{t(link.labelKey)}</Link>} />);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <DropdownMenuContent align="end">{t3}</DropdownMenuContent>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <DropdownMenu>{t2}{t4}</DropdownMenu>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}